import React, {useMemo, useRef, useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import NocService from "../../../services/noc-service";
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import NocStatusCellRenderer from "./noc-status-cell-renderer";
import {FaTimes} from "react-icons/fa";

const NocModal = ({open, set, ibge, pcl_id}) => {
    const {data} = useQuery({
        queryFn: () => NocService.status({pcl_id, ibge}).then(({data}) => data),
        queryKey: ['noc', {open}],
        enabled: open,
        retry: 0
    });

    const [columnDefs] = useState([
        {field: "status", headerName: "", cellRenderer: NocStatusCellRenderer, cellClass: "justify-center", width: 90},
        {field: "code", headerName: "ID", width: 90},
        {field: "source", headerName: "IP"},
        {field: "driver", headerName: "Fabricante/Driver"},
        {field: "smartName", headerName: "Nome do dispositivo", flex: 1, minWidth: 200},
        {field: "pinSmartcapture", headerName: "PIN do smart"},
        {field: "ipSmartcapture", headerName: "IP do smart"}
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    return (
        <Dialog open={open} onClose={set} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-10/12 overflow-y-auto m-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 w-9/12 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="bg-white py-4 border-b border-gray-300">
                            <div className="text-left">
                                <DialogTitle as="h3" className="font-semibold leading-6 border-b border-gray-300 px-3 flex justify-between">
                                    NOC - Faixas
                                    <span onClick={() => set(false)} className="cursor-pointer">

                                        <FaTimes />
                                    </span>
                                </DialogTitle>
                                <div className="mt-4 px-3">
                                    <div className={"ag-theme-quartz grid mt-4"}
                                         style={{height: "calc(100vh - 233px)"}}>
                                        <AgGridReact
                                            ref={gridRef}
                                            rowHeight={32}
                                            rowData={data ?? []}
                                            columnDefs={columnDefs}
                                            defaultColDef={defaultColDef}
                                            animateRows={false}
                                            suppressRowClickSelection={true}
                                            suppressCellFocus={true}
                                            gridOptions={{localeText: LocalizationAgGrid}}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
};

export default NocModal;